export default ({ trackLink: { savedItemAction } }) => savedItemAction;
